/*
 * General tools for conversions.
 */

import Logger from '@/logger'

export default {

    /**
     * Converts an object to a nested array of key value pair arrays.
     *
     * @param {Object} dataObject The object to convert.
     * @returns An array of arrays.
     */
    convertToKeyValuePairs(dataObject) {
        return Object.keys(dataObject).map((key) => {
            let value = dataObject[key]
            if (typeof value === 'object') {
                try {
                    value = value === null ? '' : this.convertToKeyValuePairs(value)
                } catch (error) {
                    // stop excessive recursion breaking things
                    // eslint-disable-next-line no-console
                    console.error(`${ error.message } - Review your data structure: [key: ${ key } value: ${ value }]`)
                    Logger.logObject(value, 'Error caused by object')
                }
            }
            return [ key, value ]
        })
    },

    /**
     * Converts a string to a correct boolean representation.
     *
     * @param {string} value expected either 'true' or 'false' (case insensitive).
     * @returns {boolean}
     */
    convertToBoolean(value) {
        if (value.toLowerCase() === 'true')
            return true

        if (value.toLowerCase() === 'false')
            return true

        return null
    },

    /**
     * Converts a SQL / C# Server date to a Javascript Date object.
     *
     * @param {string} serverDate
     * @returns {Date}
     */
    convertServerDateTimeToDate(serverDate) {
        //serverDate in SQL DATETIME format ("yyyy-mm-dd hh:mm:ss.ms")
        const serverDateArr1 = serverDate.split('-')
        //format of serverDateArr1[] = ['yyyy','mm','dd hh:mm:ms']
        const sYear = serverDateArr1[0]
        const sMonth = (Number(serverDateArr1[1]) - 1).toString()
        const serverDateArr2 = serverDateArr1[2].split(' ')
        //format of serverDateArr2[] = ['dd', 'hh:mm:ss.ms']
        const sDay = serverDateArr2[0]
        const serverDateArr3 = serverDateArr2[1].split(':')
        //format of serverDateArr3[] = ['hh','mm','ss.ms']
        const sHour = serverDateArr3[0]
        const sMinute = serverDateArr3[1]
        const serverDateArr4 = serverDateArr3[2].split('.')
        //format of serverDateArr4[] = ['ss','ms']
        const sSecond = serverDateArr4[0]
        const sMillisecond = serverDateArr4[1]

        return new Date(sYear, sMonth, sDay, sHour, sMinute, sSecond, sMillisecond)
    },
}
